// removed by extract-text-webpack-plugin
module.exports = {"legenda":"_3o7E57rpxyvvCom4e9P2zZ","marked":"_3P8PSd6ApMW_m6qdfjwyQK","tagsWeek":"z3BQ2mT_z8t4oYT8BerWx","checktag":"_2yT5Hd9RmTEnsOBtdsQJ7n","calendar":"_1gjYOOCpeKpMYrrjZOa8Kb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Steps/Calendar/style.module.css
// module id = 508
// module chunks = 37